import Table from '@/components/table/components/Table.tsx';
import invitationsApi from '@/features/dashboard/invitations/api/invitationsApi.ts';
import { invitationsApiQueryKeys } from '@/features/dashboard/invitations/api/invitationsApi.queryKeys.ts';
import { InvitationListDto } from '@/features/dashboard/invitations/types/InvitationListDto.ts';
import { RowContextMenuItemParams } from '@/components/table/components/RowContextMenu.tsx';
import useCancelInvitation from '@/features/dashboard/access/hooks/useCancelInvitation.ts';
import useResendInvitation from '@/features/dashboard/access/hooks/useResendInvitation.ts';

const InvitationsTable = () => {
  const cancelInvitation = useCancelInvitation();
  const resendInvitation = useResendInvitation();

  const rowContextMenuItems: RowContextMenuItemParams<InvitationListDto>[] = [
    {
      label: 'Wyślij ponownie',
      action: (row) => resendInvitation.mutate(row.id),
    },
    {
      label: 'Anuluj zaproszenie',
      variant: 'destructive',
      action: (row) => cancelInvitation.mutate(row.id),
    },
  ];

  return (
    <Table
      queryKey={invitationsApiQueryKeys.all()}
      fetchData={invitationsApi.getAll}
      fetchTableDef={invitationsApi.getTableDefinition}
      rowContextMenuItems={rowContextMenuItems}
    />
  );
};

export default InvitationsTable;
